<template>
	<div class="p-x-20 p-y-16 d-flex-between-center" @click="collapsing">
		<div class="f-bold f-16 f-c-black">
			{{ title }}
		</div>
		<div class="d-flex align-items-center">
			<div class="f-regular font-16 f-c-blue status-login m-r-12" v-if="isDiterapkan">
				<span class="font-weight-bold">
					Diterapkan
				</span>
			</div>
			<i class="fas fa-chevron-down f-c-muted" :id="'chev-' + id" v-if="isCollapsing"></i>
		</div>
	</div>
</template>

<script>
export default {
	name: "SOFilterTitle",
	props: {
		title: String,
		id: String,
		isCollapsing: {
			type: Boolean,
			default: true,
		},
		diterapkan: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			rotate: false,
			isDiterapkan: false,
		}
	},
	mounted() {
		this.isDiterapkan = this.diterapkan
	},
	watch: {
		diterapkan: {
			handler: function () {
				this.isDiterapkan = this.diterapkan
			},
			deep: true
		},
	},
	methods: {
		collapsing() {
			if (!this.isCollapsing) {
				return
			}
			let id = "#" + this.id
			$(id).slideToggle();
			let deg180 = {"transform": "rotate(180deg)"};
			let deg0 = {"transform": "rotate(0deg)"};
			this.rotate ? $('#chev-' + this.id).css(deg0) : $('#chev-' + this.id).css(deg180);
			this.rotate = !this.rotate;
		}
	}
}
</script>

<style scoped>
.fa-chevron-down {
	transition: all 300ms ease-in 0s;
}
</style>